<app-page-container id="next-step-container">
    <app-narrow-wrap>
        <h2>{{ 'REGISTER_NEXT_STEP_HEADER' | translate }}</h2>
        <p [innerHtml]="nextStepText"></p>
    </app-narrow-wrap>
</app-page-container>
